class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#CartDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("[js-cart-icon-bubble]");
		if (!cartLink) return;

		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");
		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			// this.open(cartLink);
		});
		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				// this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("overflow-hidden");
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);

			if (!sectionElement) return;
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector
			);
		});

		setTimeout(() => {
			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this)
			);
			// this.open();
		});
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);

(function () {
	document.addEventListener("rebuy.ready", initRebuyWidget.bind(this));
	document.addEventListener("rebuy:cart.add", initRebuyWidget.bind(this));
	document.addEventListener("rebuy:cart.change", initRebuyWidget.bind(this));

	function initRebuyWidget() {
		const widgetContainer = document.querySelector("[js-rebuy-widget]");
		const productsGrid = widgetContainer?.querySelector(
			"[js-rebuy-widget-products]"
		);
		if (!widgetContainer?.getAttribute("data-rebuy-widget-id")) return;

		const widget = Rebuy.widgets.find(
			(widget) =>
				widget.id === widgetContainer.getAttribute("data-rebuy-widget-id")
		);
		if (!widgetContainer || !widget) return;

		setTimeout(() => {
			const { products, cart } = widget.data;
			const lineItems = Rebuy.Cart.cart.items;

			const filteredProducts = products?.filter(
				(product) =>
					!lineItems?.some((lineItem) => lineItem.product_id === product.id) &&
					product.selected_variant.inventory_quantity > 0
			);

			if (filteredProducts?.length) {
				renderRebuyWidget(widgetContainer, filteredProducts);
				widgetContainer.classList.remove("hidden");
			} else {
				productsGrid.innerHTML = "";
				widgetContainer.classList.add("hidden");
			}
		}, 200);

		if (!document.querySelector("[js-cart-subtotal]")?.textContent) {
			setTimeout(function () {
				Rebuy.Cart.fetchCart();
			}, 2500);
		}
	}

	function renderRebuyWidget(widget, products) {
		const productsGrid = widget.querySelector("[js-rebuy-widget-products]");
		productsGrid.innerHTML = "";

		products.forEach((product) => {
			const featuredImg = product.image?.src;
			const productRte =
				product?.metafields?.custom?.product_grid_short_detail_text;
			const compareAtPrice = product.selected_variant.compare_at_price || null;
			const price = product.selected_variant.price;

			const productItemHtml = `
        <div class="product-widgets__item">
            <div class="product-widgets__image-wrap">
                <a href="/products/${product.handle}" class="product-widgets__image">
                    ${featuredImg ? `<img src="${featuredImg}" alt="${product.title.split(/[-(]/)[0].trim()}">` : ""}
                </a>
              <rebuy-atc class="atc-button" data-variant-id="${product.selected_variant.id}">
                <svg class="plus-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.00098 1.3335V14.6668" stroke="#3B3B3B" stroke-width="1.5" stroke-linecap="round"/>
                  <path d="M14.6673 8.00018H1.33398" stroke="#3B3B3B" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                <svg class="loader" xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>
              </rebuy-atc>
            </div>
            <div class="product-widgets__meta">
                ${
									productRte
										? `
                 <div class="product-widgets__inner-text">
                    ${productRte}
                </div>
                `
										: ""
								}
                <p class="product-widgets__title">${product.title.split(/[-(]/)[0].trim()}</p>
                <div class="product-widgets__price-wrap">
                    <span class="product-widgets__price">$${price}</span>
                    ${compareAtPrice > price ? `<span>-</span> <span class="product-widgets__compare_at_price">$${compareAtPrice}</span>` : ""}
                </div>
            </div>
        </div>
        `;

			productsGrid.insertAdjacentHTML("beforeend", productItemHtml);
		});
	}
})();
